import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";
import { showToast } from "../components/ui/toast";

export const useGetProductTagsQuery = (keyType, enabled = true) => {
  const { data, isPending, isError } = useQuery({
    queryKey: ["productTags", keyType],
    queryFn: () => api.get(API_ROUTES.GET_PRODUCT_TAGS, { params: keyType ? { keyType } : {} }),
    staleTime: 5 * 60 * 1000,
    enabled,
  });
  return { data: data?.data?.data ?? [], isPending, isError };
};

export const useCreateProductTagMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.post(API_ROUTES.CREATE_PRODUCT_TAG, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["productTags", variables.keyType] });
    },
    onError: (err) =>
      showToast("error", err?.response?.data?.message || "Failed to create product tag"),
  });
};

export const useUpdateProductTagMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, keyType, product, splits }) =>
      api.put(`${API_ROUTES.UPDATE_PRODUCT_TAG}/${id}`, splits ? { splits } : { product }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["productTags", variables.keyType] });
    },
    onError: (err) =>
      showToast("error", err?.response?.data?.message || "Failed to update product tag"),
  });
};
